/*---------------------------------------------------------------------------------------------
 *  Copyright (c) 2023 Vienna Hypertext Inc. All rights reserved.
 *--------------------------------------------------------------------------------------------*/

import styled from "styled-components";

import { BaseBlockContent } from "src/components/Block/styles";

export const StyledFileBlockContent = styled(BaseBlockContent)`
  overflow: hidden;
`;

export const IconWrapper = styled.span`
  margin-bottom: 12px;
`;

export const FileBlockWrapper = styled.div`
  text-decoration: underline;
  color: #aeaeae;
  &:hover {
    color: ${({ theme }) => theme.text.default};
  }
  display: flex;
  align-items: center;
  justify-content: center;
  flex-direction: column;
  font-family: "IBM Plex Mono";
  word-break: break-all;
  padding: 15px;
  height: 100%;
`;

export const FileName = styled.span`
  text-align: center;
  font-size: 14px;
  font-weight: 500;
  margin-top: 5px;
`;
